import { NgModule } from '@angular/core';

import { HisCoreSharedModule } from '../core/his-core-shared.module';


/**
 * SharedModule for authentication and authorization
 */
@NgModule( {
    imports: [
        HisCoreSharedModule
    ]

    // NO PROVIDERS! Providers need to go into HisCoreCoreModule
} )
export class HisAuthSharedModule { }
